import {
  Button,
  Card,
  Group,
  Modal,
  PinInput,
  rem,
  Space,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Countdown from "components/common/count-down/CountDown";
import { maskCharacter } from "utils/common";
import NotificationPopup from "../popup/notifications-popup/NotificationPopup";

const OTpCode = ({
  opened,
  close,
  countdown,
  setCountdown,
  isExpired,
  setIsExpired,
  setShowSuccessModal,
}: any) => {
  const { t } = useTranslation();

  const theme = useMantineTheme();
  const [cdk, setCdk] = useState(
    Math.floor(Math.random() * Date.now()).toString()
  );
  const [titlePopup, setTitlePopup] = useState("");
  const [descriptionPopup, setDescriptionPopup] = useState("");
  const [otp, setOtp] = useState("");

  const [openedNoti, { open: openNoti, close: closeNoti }] =
    useDisclosure(false);
  const countDownCompleted = () => {
    close();
    setTitlePopup(`${t("NOTIFICATION")}`);
    setDescriptionPopup(`${t("OTP_ENDED")}`);
    openNoti();
  };
  const sendOTP = async () => {
    const random = Math.floor(Math.random() * Date.now()).toString();
    setCdk(random);
  };

  const resetOtp = () => {
    sendOTP();
  };

  const handleNext = () => {
    if (otp.length === 6) {
      close(); // Đóng modal OTP
      setShowSuccessModal(true); // Mở modal thông báo đổi mật khẩu thành công
    }
  };

  return (
    <>
      <Modal opened={opened && !isExpired} onClose={close} centered>
        <Card radius="md" pb={rem(30)}>
          <Card.Section inheritPadding py="xs">
            <Group
              position="center"
              sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: "10px",
              }}
            >
              <Text
                align="center"
                style={{ marginBottom: "-10px" }}
                fw={700}
                fz="lg"
              >
                {t("OTP_VERIFY")}
              </Text>
              <Text align="center" fz="sm" w="90%" color={theme.colors.dark[3]}>
                {/* {t("SEND_OTP_VIA_PHONE_NUMBER", {
                  phone: `${maskCharacter(stateAuth.user.mobilePhone2)}`,
                })} */}
                {t("SEND_OTP_VIA_PHONE_NUMBER", {
                  phone: `${maskCharacter("0987655679")}`,
                })}
              </Text>
              <Text
                align="center"
                style={{ marginBottom: "-10px" }}
                fw={700}
                fz="sm"
              >
                {t("OTP_INPUT")}
              </Text>
              <PinInput
                oneTimeCode
                size="md"
                type="number"
                length={6}
                onChange={setOtp}
                value={otp}
              />
              <Group position="center">
                <Text fz="xs" color={theme.colors.dark[3]}>
                  {t("TIME_EFFECT")}
                </Text>
                <Button w={60} color="tertiary" compact>
                  <Countdown
                    time={1}
                    cdk={cdk}
                    countDownCompleted={countDownCompleted}
                  />
                </Button>
                <Text
                  style={{ cursor: "pointer" }}
                  align="center"
                  color={theme.colors.tertiary[9]}
                  fz="xs"
                  onClick={resetOtp}
                >
                  {t("RESEND_OTP")}
                </Text>
              </Group>
              <Space h={20} />
            </Group>
            <Group position="center" mt={rem(20)}>
              <Button color="gray" variant="outline" onClick={close}>
                {t("BACK")}
              </Button>
              <Button
                color="primary"
                onClick={handleNext}
                disabled={otp.length !== 6}
              >
                {t("NEXT")}
              </Button>
            </Group>
          </Card.Section>
        </Card>
      </Modal>
      <NotificationPopup
        opened={openedNoti}
        close={closeNoti}
        title={titlePopup}
        description={descriptionPopup}
        closeModal={closeNoti}
      />
    </>
  );
};

export default OTpCode;
